import React from "react";

import styles from "../Sidebar.module.css";

import { SidebarShortcutMediumRapidEntry } from "../SidebarShortcuts";

// Icons
import { ReactComponent as ComparisonIcon } from "./Icons/comparison_48.svg";
import { ReactComponent as PsoriasisCalculationIcon } from "./Icons/psoriasis_calculation_48.svg";
import { ReactComponent as PsoriasisSegmentationIcon } from "./Icons/psoriasis_segmentation_48.svg";
import { ReactComponent as BodySegmentationIcon } from "./Icons/body_segmentation_48.svg";

const RapidSlideOutPanel = () => {
  const ENTRY_MODULES = JSON.parse(process.env.REACT_APP_ENTRY_MODULES || "[]");

  return (
    <>
      <div
        className={`flex flex-col h-full w-full pt-3 p-2 overflow-y-scroll ${styles["hide-scrollbar"]} Xbg-blue-500`}
      >
        {ENTRY_MODULES.includes("photo") && (
          <SidebarShortcutMediumRapidEntry
            shortcutText={"Compare"}
            Icon={ComparisonIcon}
            apiPath="entries/comparison_menu/1/"
            newItemPath="/entries/rapid/comparison/"
          />
        )}
        {ENTRY_MODULES.includes("psoriasis") && (
          <SidebarShortcutMediumRapidEntry
            shortcutText={"Psoriasis Calculate"}
            Icon={PsoriasisCalculationIcon}
            apiPath="entries/psoriasis_menu/1/"
            newItemPath="/entries/rapid/psoriasis_calculation/"
          />
        )}
        {ENTRY_MODULES.includes("psoriasis") && (
          <SidebarShortcutMediumRapidEntry
            shortcutText={"Psoriasis Segment"}
            Icon={PsoriasisSegmentationIcon}
            apiPath="entries/psoriasis_segmentation_menu/1/"
            newItemPath="/entries/rapid/psoriasis_segmentation/"
          />
        )}
        {ENTRY_MODULES.includes("ai_assisted") && (
          <SidebarShortcutMediumRapidEntry
            shortcutText={"Body Segment"}
            Icon={BodySegmentationIcon}
            apiPath="entries/segmentation_menu/1/"
            newItemPath="/entries/rapid/regular_segmentation/"
          />
        )}
      </div>
    </>
  );
};

export default RapidSlideOutPanel;
